import {uniqueId} from 'lodash'

const routeToEmployeeCard = {
  name: 'UserCard',
  params: {
    id: 'id'
  },
  paramName: 'id',
  paramValue: '_id',
  props: true
}

const columns = [
  {
    type: 'index',
    width: '26px',
    prop: 'position'
  },
  {
    title: 'NICKNAME',
    prop: 'username',
    capitalize: true,
    typeTable: 'kpiTable',
    openModal: {
      display: true,
      hide: true
    },
    route: routeToEmployeeCard
  },
  {
    title: 'TARGET',
    prop: 'position.percent100',
    type: 'number'
  },
  {
    title: 'EARNED',
    prop: 'earned',
    actionType: 'openKpiEarnedTable',
    type: 'number',
    hover: true,
    mark: 'earned'
  },
  {
    title: 'FOR APPROVAL',
    prop: 'forApproval',
    hover: true,
    actionType: 'openKpiEarnedTable',
    mark: 'forApproval',
    type: 'number',
    forProject: true
  },
  {
    title: 'POTENTIAL',
    prop: 'potential',
    actionType: 'openKpiEarnedTable',
    type: 'number',
    hover: true,
    mark: 'potential'
  },
  {
    title: 'CURRENT KPI',
    prop: 'currentKPI',
    postfix: '%',
    percent: {
      number: 'potential',
      of: 'position.percent100'
    },
    type: 'number'
  },
  {
    title: 'BONUS TO BE PAID',
    prop: 'bonusToBePaid',
    type: 'number'
  },
  {
    title: 'TRANSFER',
    prop: 'earned',
    type: 'transferCell',
    actionType: 'openTransfer'
  }
]

const prefix = 'kpi_column_'
const kpiTableColumns = columns.map(col => {
  col.id = uniqueId(prefix)
  return col
})
export default kpiTableColumns



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/kpiTable.js